import { render } from "./home.vue?vue&type=template&id=586cd99e&scoped=true"
import script from "./home.vue?vue&type=script&lang=js"
export * from "./home.vue?vue&type=script&lang=js"

import "./home.vue?vue&type=style&index=0&id=586cd99e&lang=scss&scoped=true"
import "./home.vue?vue&type=style&index=1&id=586cd99e&lang=scss"

import exportComponent from "/Users/hou/Desktop/zijie/sdxlxh_user/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-586cd99e"]])

export default __exports__